export default __webpack_public_path__ + "static/media/Wine-Cake.670f1347.jpg";